export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00890.b73270ba.png";